import { FIELDGROUP } from "./action";

const initialState = {
  fieldGroupList: [],
  fieldGrpCreated: [],
  selectedGrp: {},
  grpUpdated: {}
};

export default function fieldGroupReducer(state = initialState, action) {
  switch (action.type) {
    case FIELDGROUP.getAllFieldGroupList.success:
      return {
        ...state,
        fieldGroupList: action.data,
        fieldGrpCreated: {},
        grpUpdated: {}
      };
    case FIELDGROUP.create.success:
      return {
        ...state,
        fieldGrpCreated: action.data
      };
    case FIELDGROUP.edit.success:
      return {
        ...state,
        selectedGrp: action.data
      };
    case FIELDGROUP.update.success:
      return {
        ...state,
        grpUpdated: action.data
      };
    case FIELDGROUP.delete.success:
      const commId = action.data.id;
      return {
        ...state,
        fieldGroupList: state.fieldGroupList.filter(comm => comm.id !== commId)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/fieldgroups/reducer.js